<template>
  <Button
    :label="locale === 'nl' ? 'EN' : 'NL'"
    text
    size="small"
    @click="toggle"
  />
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'

const { locale } = useI18n()

function toggle() {
  locale.value = locale.value === 'nl' ? 'en' : 'nl'
}
</script>
